module.exports = __webpack_public_path__ + "img/Weilin Vision Cotton Mask Detection Software.7015dc8a.jpg";